import React, { useState, useCallback, useEffect, useRef } from "react";
import { connect } from "react-redux";
import { GridLayout } from "../../../common/GridLayout";
import { useHistory } from "react-router-dom";
import {
    Column,
    DataGrid,
    GroupPanel,
    Scrolling,
    Grouping,
    FilterRow,
    Lookup,
    FilterPanel,
    Sorting,
    Paging,
    Selection,
    Toolbar,
    Item,
  Export,
  Pager,
  ColumnChooser,
  ColumnChooserSearch,
  StateStoring,
  ColumnHeaderFilter
} from "devextreme-react/data-grid";
import { Button } from 'devextreme-react/button';
import GridLayoutManager from "../../../gridLayoutCustomization/GridLayoutManager";
const InvoicesSearchResult = (props) => {
    const dataGrid = useRef(null);
    var accessToken = props.oidc.user.access_token;
    const history = useHistory();
    const [selectedRowId, setSelectedRowId] = useState(null);
    const childRef = useRef();
    const allowedPageSizes = [10, 20, 100, 500, 1000, "all"];
    const gridKey = "DFC6AF5F-299E-4753-BCBF-A56234BA9D19";
    const [currentLayout, setCurrentLayout] = useState("Default");
    const saveState = useCallback((state) => { GridLayout.sendStorageRequest(gridKey, "POST", accessToken, state, currentLayout); }, [gridKey, currentLayout]);

    const loadState = useCallback(() => { return GridLayout.sendStorageRequest(gridKey, "GET", accessToken,null,currentLayout); }, [currentLayout]);
    const onSelectionChanged = ({ selectedRowsData }) => {
        const selectedRowData = selectedRowsData[0];
        if (selectedRowData) {
            setSelectedRowId(selectedRowData.rowid); // Set the rowid to selectedRowId
        } else {
            setSelectedRowId(null); // Reset if no rows are selected
        }
        if (childRef.current) {
            childRef.current.updateData(selectedRowData);
        }
    };
    const handleUpdateClick = () => {
        if (selectedRowId) {
            console.log("Update clicked for row ID: ", selectedRowId);
            history.push(`/wm/UpdateInvoice/${selectedRowId}`);
        }
    };

    return (
        <div>
            <DataGrid

onExporting={(e) => {
          if (window.handleDevExtremeDataGridExport) {
            window.handleDevExtremeDataGridExport(e);
          }
        }}
                ref={dataGrid}
                dataSource={props.data}
                allowColumnReordering={true}
                allowColumnResizing={true}
                showBorders={true}
                hoverStateEnabled={true}
                className={props.searchPanelStatus ? "GridHeightAccordianOpen" : "GridHeightAccordianClose"}
                searchExpr="status"
                remoteOperations={true}
                searchEnabled={true}
                columnAutoWidth={true}
                scrolling={{ mode: "standard" }}
                onSelectionChanged={onSelectionChanged}
            >
                <ColumnChooser
                    enabled={true}
                    title="Choose Column"
                    width={290}
                    height={290}
                    sortOrder="asc"
                >
                    <ColumnChooserSearch
                        enabled={true}
                        editorOptions={{ placeholder: 'Search column' }} />
                </ColumnChooser>
                <ColumnHeaderFilter />
                <Export enabled={true} allowExportSelectedData={true} />
                <Selection mode="single" />
                <Sorting visible={true} mode="multiple" />
                <Paging defaultPageSize={10} />
                <Pager
                    visible={true}
                    showPageSizeSelector={true}
                    allowedPageSizes={allowedPageSizes}
                    showNavigationButtons={true}
                />
                <FilterRow visible={true} />
                <FilterPanel visible={true} />
                <GroupPanel visible={true} />
                <Grouping autoExpandAll={false} />
                <StateStoring
                    enabled={true}
                    type="custom"
                    customLoad={loadState}
                    storageKey={gridKey}
                    customSave={saveState}
                />
                <Scrolling rowRenderingMode="virtual" />
                <FilterRow visible={true} />
                <Scrolling mode="virtual" />
                <Column dataField="identityId" caption="Customer" dataType="string" />
                <Column dataField="name" caption="Name" dataType="string" />
                <Column dataField="creationDatetime" caption="Creation Date" dataType="date" format="MM/dd/yyyy" />
                <Column dataField="invoiceNumber" caption="Invoice#" dataType="string" />
                <Column dataField="invoiceDate" caption="Invoice Date" dataType="date" format="MM/dd/yyyy" />
                <Column dataField="status" caption="Status" dataType="string" />
                <Column dataField="creationUserId" caption="Creation By" dataType="string" visible={false} />
                <Column dataField="lastUpdateDatetime" caption="Last Updated" dataType="date" format="MM/dd/yyyy" visible={false} />
                <Column dataField="lastUpdateUserId" caption="Last Update By" dataType="string" visible={false} />
                <Column dataField="description" caption="Description" dataType="string" visible={false} />

                <Column dataField="transactionType" caption="Transaction Type" dataType="string" visible={false} />
                <Column dataField="referenceNumber" caption="Reference#" dataType="string" visible={false} />
                <Column dataField="frequence" caption="Frequence" dataType="string" visible={false} />
                <Column dataField="fiscalYear" caption="Fiscal Year" dataType="number" visible={false} />
                <Column dataField="fiscalPeriod" caption="Fiscal Period" dataType="number" format={{ type: 'fixedPoint', precision: 0 }} visible={false} />
                <Column dataField="commitDate" caption="Commit Date" dataType="date" format="MM/dd/yyyy" visible={false} />
                <Column dataField="dueDate" caption="Due Date" dataType="date" format="MM/dd/yyyy" visible={false} />
                <Column dataField="invoiceTitle" caption="Invoice Title" dataType="string" visible={false} />
                <Column dataField="printInvoice" caption="Print Invoice" dataType="string" visible={false} />
                <Column dataField="transCurrencyType" caption="Trans Currency Type" dataType="string" visible={false} />
                <Column dataField="payCurrencyType" caption="Pay Currency Type" dataType="string" visible={false} />
                <Column dataField="rPayCurrencyCode" caption="RPay Currency Code" dataType="string" visible={false} />
                <Column dataField="transCurrency" caption="Trans Currency" dataType="string" visible={false} />
                <Column dataField="payCurrency" caption="Pay Currency" dataType="string" visible={false} />
                <Column dataField="termsDueDateType" caption="Terms Due Date Type" dataType="string" visible={false} />
                <Column dataField="termsDueDateMonth" caption="Terms Due Date Month" dataType="number" format={{ type: 'fixedPoint', precision: 0 }} visible={false} />
                <Column dataField="termsDueDateDay" caption="Terms Due Date Day" dataType="number" format={{ type: 'fixedPoint', precision: 0 }} visible={false} />
                <Column dataField="rateTiming" caption="Rate Timing" dataType="string" visible={false} />
                <Column dataField="presetRate" caption="Preset Rate" dataType="number" format={{ type: 'fixedPoint', precision: 2, useGrouping: true }} visible={false} />
                <Toolbar>
                    <Item location="before">
                        <Button
                            text="Update"
                            disabled={!selectedRowId} // Disable button if no row is selected
                            onClick={handleUpdateClick}
                            type="default"
                        />
                    </Item>
                    <Item location="after">
                        <GridLayoutManager gridKey={gridKey} dataGrid={dataGrid} setCurrentLayout={setCurrentLayout} />
                    </Item>
                    <Item name="exportButton" />
                    <Item name="columnChooserButton" />
                </Toolbar>
            </DataGrid>
        </div>
    )
};
function mapStateToProps(state) {
    return {
        ReceiptReducer: state.ReceiptReducer,
        oidc: state.oidc,
    };
}
export default connect(mapStateToProps)(InvoicesSearchResult);